/**
 * created by lei lei
 * 横向管控内容安全管理
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from "react-custom-scrollbars";
import {Tabs} from "antd";
import SystemDetection from './SystemDetection'
import ManualDetection from './ManualDetection'
import Title from "../../../components/title/Title";
import weChat from "../manageControlStatistics/img/wechat.png";
import microBlog from "../manageControlStatistics/img/microBlog.png";
import tiktok from "../manageControlStatistics/img/tiktok.png";
import PageScrollBars from '../../../components/pageScrollBars/PageScrollBars'
import SpacerBlock from '../../../components/spacerBlock/SpacerBlock'

const {TabPane} = Tabs;

export default class ContentSecurityManagement extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            detectionType: '0'
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <PageScrollBars content={
                <div className={'ContentSecurityManagement'}>
                    <div style={{paddingLeft: 10, background: 'white'}}>
                        <Tabs defaultActiveKey={this.state.detectionType}
                              activeKey={this.state.detectionType}
                              onChange={(key) => {
                                  this.state.detectionType = key;
                                  this.setState({})
                              }} tabBarGutter={0}>
                            <TabPane tab={'系统监测'} key={'0'}>
                            </TabPane>
                            <TabPane tab={'手动检测'} key={'1'}>
                            </TabPane>

                        </Tabs>
                    </div>
                    <div style={{width: '100%'}}>
                        {
                            this.state.detectionType === '0' ? <SystemDetection/> : <ManualDetection/>
                        }
                    </div>
                </div>
            }/>
        )
    }

}